import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { interactions } from "@/mocks/home";

export default function InteractionDetails() {
  const [open, setOpen] = useState(0);

  return (
    <section id="details" className="section-anchor bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="INTERACTION DEPTH"
              title="互动细节的六个切面"
              desc="真正推动关系的，往往不是发生了什么，而是一个停顿、一段距离或一次没有说出口的退让。"
            />
            <div className="mt-6 rounded-lg border border-background-200 bg-secondary-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-secondary-900">
                <i className="ri-lightbulb-flash-line" />
                阅读提示
              </h3>
              <p className="mt-3 text-sm leading-7 text-secondary-900/80">
                展开任意一条，可以看到该切面在场景中具体表现为哪些动作与信号，以及它如何影响关系的走向。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ul className="space-y-3">
              {interactions.map((item, index) => {
                const isOpen = open === index;
                return (
                  <li
                    key={item.title}
                    className={`rounded-lg border bg-background-100/60 transition-colors ${
                      isOpen ? "border-primary-300" : "border-background-200"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? -1 : index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center gap-4 px-5 py-4 text-left"
                    >
                      <span
                        className={`w-10 h-10 shrink-0 rounded-md flex items-center justify-center transition-colors ${
                          isOpen
                            ? "bg-primary-500 text-background-50"
                            : "bg-primary-500/12 text-primary-700"
                        }`}
                      >
                        <i className={`${item.icon} text-xl`} />
                      </span>
                      <span className="flex-1 font-heading text-base md:text-lg font-bold text-foreground-950">
                        {item.title}
                      </span>
                      <i
                        className={`shrink-0 text-foreground-500 transition-transform ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                      />
                    </button>
                    {isOpen && (
                      <p className="px-5 pb-5 pl-[4.75rem] text-sm md:text-base leading-8 text-foreground-700">
                        {item.desc}
                      </p>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}